exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2_title[data-v-2a21fb04] {\n  font-weight: normal;\n}\n", ""]);

// exports
